import React from 'react'
import { useConnectionStatus } from './hooks/useConnectionStatus'
import AppRouter from './AppRouter'

const App: React.FC = () => {
  useConnectionStatus()

  return (
    <div className='min-h-screen flex flex-col justify-center'>
      <div className=''>
        <AppRouter />
      </div>
    </div>
  )
}

export default App
